/*@ngInject*/
export default function config($locationProvider, $mdThemingProvider, $httpProvider, $mdDateLocaleProvider, $localStorageProvider, $mdGestureProvider) {
	$locationProvider.html5Mode(true);
	$mdThemingProvider.theme("danger-toast");
	$httpProvider.interceptors.push('HttpInterceptor');

	$mdDateLocaleProvider.firstDayOfWeek = 1;
	$mdDateLocaleProvider.dates = [
		'', '01', '02', '03', '04', '05', '06', '07', '08', '09',
		'10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
		'20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
		'30', '31',
	];
	$mdDateLocaleProvider.shortDays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
	moment.locale('de');  // Set the default/global locale
	$mdDateLocaleProvider.formatDate = function(date) {
		if (date == null){
			return '';
		}
		return moment(date).format('L');
	};
	$mdDateLocaleProvider.parseDate = function(dateString) {
		var m = moment(dateString, 'L', true);
		return m.isValid() ? m.toDate() : new Date(NaN);
	};

    $mdGestureProvider.skipClickHijack();
	$localStorageProvider.setKeyPrefix('WcoDaisyApp-');
}
